import React, { useContext, useState, useEffect } from 'react';
import DriverProfile from './public/driverProfile.svg';
import { useDispatch, useSelector } from "react-redux";
import SendIcon from './public/SendIcon.svg';
import { StateApp } from '../context/Context';
import axios from 'axios';
import { url } from '../url';
import { useNavigate, useLocation } from 'react-router-dom';
import { GiCarWheel } from "react-icons/gi";
import { TbMapPinFilled } from "react-icons/tb";
import Modal from "react-modal";
import carMapic from './public/car-service-svgrepo-com.svg'
import LoginRegister from '../Login/LoginRegister';
import SuccessLogin from '../Modal/Success Login';
import { IoMdArrowBack } from "react-icons/io";
import { RiArrowGoBackLine } from "react-icons/ri";
import backArrow from "../../src/PassengerTrip/public/backArrow.svg"
import ArrowIcon from './public/arrowIcon.svg'
import { subscribeToForegroundMessages } from '../firebase';
import { getSocket, joinTravelRoom, leaveTravelRoom, SOCKET_EVENTS } from '../socket';
import { IoArrowBack, IoCheckmarkDone, IoChatbubbleEllipsesOutline, IoCarSportOutline, IoSend } from "react-icons/io5";

// نمایش ساعت پیام به وقت تهران بدون نیاز به moment-timezone
const formatTehranTime = (date) =>
  new Date(date).toLocaleTimeString('fa-IR', {
    hour: '2-digit',
    minute: '2-digit',
    hour12: false,
    timeZone: 'Asia/Tehran',
  });

// ===== کامپوننت کمکی: حباب پیام =====
const MessageBubble = ({ item }) => {
  const isDriver = item.sender?.driver;

  return (
    <div className={`flex ${isDriver ? 'justify-start' : 'justify-end'} chat-msg-enter`}>
      <div
        className={`
          max-w-[78%] px-4 py-2.5 shadow-sm transition-all duration-300
          ${isDriver
            ? 'bg-white rounded-2xl rounded-bl-sm border border-slate-200 text-slate-800 shadow-slate-200/60'
            : 'bg-[#4F48EC] rounded-2xl rounded-br-sm text-white'
          }
        `}
      >
        <p className="text-[15px] leading-7 whitespace-pre-wrap break-words">
          {item.message}
        </p>
        <div className={`flex items-center justify-end gap-1 mt-1 ${
          isDriver ? 'text-slate-400' : 'text-white/80'
        }`}>
          <span className="text-[11px] tabular-nums" style={{ fontFamily: 'IRANSansFaNum' }}>
            {formatTehranTime(item.createdAt)}
          </span>
          {!isDriver && <IoCheckmarkDone className="text-xs" />}
        </div>
      </div>
    </div>
  );
};

// ===== کامپوننت کمکی: حالت خالی =====
const EmptyChatState = () => (
  <div className="flex flex-col items-center justify-center py-16 px-6 text-center chat-msg-enter">
    <div className="w-24 h-24 rounded-full bg-indigo-50 flex items-center justify-center mb-5 shadow-inner">
      <IoChatbubbleEllipsesOutline className="w-12 h-12 text-[#4F48EC]" />
    </div>
    <h3 className="text-lg font-bold text-slate-700 mb-2">هنوز پیامی رد و بدل نشده</h3>
    <p className="text-sm text-slate-500 max-w-xs leading-6">
      اولین پیام را برای راننده ارسال کنید تا گفتگو آغاز شود
    </p>
  </div>
);

const ChatPage = () => {

  const { state } = useLocation() // travel id
  console.log(state)

  const defaultMessages = ["تماس میگیرم", "الان میام", "در مبدا منتظرتونم.", "چند دقیقه دیگه میرسید؟", "لطفا چند دقیقه در مبدا منتظر بمانید."];
  const [message, setMessage] = useState("");
  const [allMessages, setAllMessages] = useState([]);
  const { travelId } = useContext(StateApp);
  const { driverInfo, setDriverInfo } = useContext(StateApp);
  const { userInfo, error } = useSelector((state) => state.userinformation);
  const [passenderId, setPassengerId] = useState("");
  const [driverId, setDriverId] = useState("");
  const { accessToken } = userInfo;
  const [tripId, setTripId] = useState("");
  const [errHandle, setErrHandle] = useState(false);
  const [noMessages, setNoMessages] = useState(true)
  const [reloadAnimation, setReloadAnimation] = useState(false);
  const [networkConnection, setNetworkConnection] = useState(false)
  const [apiRecall, setApiRecall] = useState(false);
  const [updateMessages, setUpdateMessages] = useState(false)
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [noToken, setNoToken] = useState(false)
  const [noActiveTravel, setNoActiveTravel] = useState(false)

  const {
    carInfo, setCarInfo, loading,
    setLoading, openLogin, showSuccessLogin,
    updateUserName_header, setUpdateUserName_header,
    goToOptionPage, setGoToOptionPage
  } = useContext(StateApp)

  let today = new Date().toLocaleDateString('fa-IR', { month: 'long', day: 'numeric' });

  let navigate = useNavigate();

  const tryAgain = () => {
    setTimeout(() => {
      setApiRecall(prev => !prev)
      setReloadAnimation(false);
    }, 3000);
    setReloadAnimation(true);
  }

  const handleCancel = () => {
    setIsModalOpen(false)
  }

  const customStyles = {
    content: {
      top: '50%',
      left: '50%',
      right: 'auto',
      bottom: 'auto',
      marginRight: '-50%',
      padding: '0px',
      transform: 'translate(-50%, -50%)',
      position: 'absolute',
      borderRadius: '10px',
      outline: 'none',
      border: 'none'
    },
    overlay: {
      backgroundColor: 'rgba(0, 0, 0, 0.8)',
    }
  };

  useEffect(() => {
    setNoActiveTravel(false)
    setNetworkConnection(false)
    setNoToken(false)
    axios.get(`${url}/travel/v1/get-single-travel-passenger/${state}`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('accessToken')}`
      }
    }).then((res) => {
      console.log(res)
      setDriverInfo(res.data?.data?.driver_snapshot);
      setCarInfo(res.data?.data?.car_snapshot);
      setPassengerId(res.data?.data?.passenger?._id);
      setDriverId(res.data?.data?.driver?._id);
      setTripId(res.data?.data?._id);
      setNoActiveTravel(false)
      setNetworkConnection(false)
      setNoToken(false)
      setTripId(res.data?.data?._id);
    })
      .catch(err => {
        if (err?.response?.data?.status === 404)
          setNoActiveTravel(true)
        if (err?.message === "Network Error") {
          setNetworkConnection(true)
        }
        if (err?.response?.data)
          setNoToken(true)
      });

  }, [apiRecall, showSuccessLogin])


  const [reload, setReload] = useState(false)

  useEffect(() => {
    let active = true;
    let unsubscribe = () => {};

    subscribeToForegroundMessages(() => {
      setReload(prev => !prev);
    }).then((listener) => {
      if (!active) {
        if (typeof listener === "function") listener();
        return;
      }

      unsubscribe = listener;
    }).catch((error) => {
      console.error("Foreground notification subscription failed:", error);
    });

    return () => {
      active = false;
      if (typeof unsubscribe === "function") unsubscribe();
    };
  }, []);

  // --- WebSocket: دریافت لحظه‌ای پیام جدید بدون رفرش ---
  useEffect(() => {
    const socket = getSocket();
    if (!socket || !state) return;

    joinTravelRoom(state);

    const onNewMessage = (payload) => {
      // فقط پیام‌های همین سفر
      if (payload?.travel_id && String(payload.travel_id) !== String(state)) return;
      if (payload?.message) {
        setAllMessages(prev => {
          // جلوگیری از پیام تکراری (وقتی خودمان فرستنده هستیم)
          const exists = prev.some(m => m._id && m._id === payload.message._id);
          return exists ? prev : [...prev, payload.message];
        });
        setNoMessages(false);
      }
    };

    socket.on(SOCKET_EVENTS.TRAVEL_MESSAGE_CREATED, onNewMessage);

    return () => {
      socket.off(SOCKET_EVENTS.TRAVEL_MESSAGE_CREATED, onNewMessage);
      leaveTravelRoom(state);
    };
  }, [state]);

  useEffect(() => {
    setNoMessages(false)
    setNetworkConnection(false)
    setNoToken(false)
    axios.get(`${url}/travel-message/v1/get-passenger-single-travel-messages/${state}`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("accessToken")}`
      }
    }).then(res => {
      setNoMessages(false)
      setNetworkConnection(false)
      setNoToken(false)
      setAllMessages(res.data.data)

    }).catch(err => {
      if (err?.response?.data?.status === 404)
        setNoMessages(true)
      if (err?.message === "Network Error") {
        setNetworkConnection(true)
      }
      // if (err?.response?.data)
      //   setNoToken(true)
    })
  }, [apiRecall, showSuccessLogin, updateMessages, reload])


  const sendMessage = () => {
    if (message.trim()) {
      setMessage("");
    }
    // Send message
    axios.post(`${url}/travel-message/v1/passenger-send-message`,
      {
        message: message,
        travel_id: tripId
        // passenger_id: passenderId
      },
      {
        headers: {
          Authorization: `Bearer ${accessToken}`
        }
      }).then(res => {
        setUpdateMessages(prev => !prev)
      })
      .catch(error => {

      });
  };


  return (
    <div className='mk-page mk-chat h-screen flex flex-col justify-between relative bg-slate-50'>
      {
        // ---- no internet ----
        networkConnection ? (
          <div className='flex items-center justify-center py-10 px-5 h-full'>
            <div className='flex items-center gap-5 w-full flex-col max-w-md'>
              <div className='w-24 h-24 rounded-full bg-red-50 flex items-center justify-center mb-2 shadow-inner'>
                <div className='w-16 h-16 rounded-full bg-red-500 text-white text-4xl flex items-center justify-center font-bold shadow-lg shadow-red-200'>
                  !
                </div>
              </div>
              <div className='text-center'>
                <h2 className='text-lg font-bold text-slate-800 mb-2'>خطا در برقراری ارتباط</h2>
                <p className='text-sm text-slate-500 leading-6'>لطفا اتصال اینترنت خود را بررسی کنید و دوباره تلاش کنید</p>
              </div>
              <div className={`flex items-center gap-2 text-sm text-slate-600 ${reloadAnimation ? "opacity-100" : "opacity-0"} transition-opacity`}>
                <GiCarWheel className={`${reloadAnimation && "animate-spin text-[20px] text-[#4F48EC]"}`} />
                <span>منتظر بمانید...</span>
              </div>
              <button
                className='mk-chat-retry px-8 py-2.5 rounded-xl bg-[#4F48EC] text-white font-medium active:scale-95 transition-all mt-4'
                onClick={tryAgain}
              >
                تلاش مجدد
              </button>
            </div>
          </div>
        ) : (
          <>
            {
              // ---- no token ----
              noToken ? (
                <div className={`w-full h-full flex-col items-center text-[30px] flex`}>
                  <div className='flex flex-col gap-x-5 items-center mt-[50px]'>
                    <div className='text-[18px] text-center'>
                      <p className='mb-5 text-[24px] font-bold text-darkBlue'>
                        مارانکو سفری مطمئن !
                      </p>
                      <p className='mb-5 px-10 text-gray-600'>
                        با مارانکو به هرجایی که خواستید به راحتی سفر کنید
                      </p>
                    </div>
                    <img src={carMapic} className="w-48 h-48" />

                    <div className='flex flex-col mt-10 w-full px-5'>
                      <div className='flex gap-x-5 items-center justify-center h-full '>
                        <p className='text-[24px] font-bold text-darkBlue'>
                          شما وارد حساب کاربری نشده اید !
                        </p>
                      </div>

                      <div className='flex gap-x-2 md:flex-col w-full'>
                        <button onClick={() => setIsModalOpen(true)} className='py-2 md:w-[40%] text-[18px] mt-5 rounded-full bg-applyingbuttoncolor text-white
                      hover:opacity-90 transition duration-300 mx-auto w-full shadow-md'>ثبت نام</button>

                        <button onClick={() => navigate("/passengersTrips")} className='py-2 md:w-[40%] text-[18px] mt-5 md:mt-2 rounded-full border-2 border-red-500 text-red-500
                      hover:bg-red-500 hover:text-white transition duration-300 mx-auto w-full'>برگشت</button>
                      </div>

                    </div>
                  </div>
                </div>
              ) : (
                <>
                  {
                    // ---- no active travel ----

                    noActiveTravel ? (
                      <div className={`w-full h-full flex flex-col items-center text-[30px] flex`}>
                        <div className='flex flex-col gap-x-5 items-center mt-[50px]'>
                          <div className='text-[18px] text-center'>
                            <p className='mb-5 text-[24px] font-bold text-darkBlue'>
                              مارانکو سفری مطمئن !
                            </p>
                            <p className='mb-5 px-10 text-gray-600'>
                              با مارانکو به هرجایی که خواستید به راحتی سفر کنید
                            </p>
                          </div>
                          <img src={carMapic} className="w-48 h-48" />

                          <div className='flex flex-col mt-10 w-full px-5'>
                            <div className='flex gap-x-5 items-center justify-center h-full '>
                              <TbMapPinFilled className="animate-bounce text-[45px] text-yellow-500" />
                              <p className='text-[24px] font-bold text-darkBlue'>
                                در انتظار تایید راننده
                              </p>
                            </div>
                            <button onClick={() => navigate("/passengersTrips")} className='py-2 md:w-[40%] text-[18px] mt-5 rounded-full border-2 border-red-500 text-red-500
                            hover:bg-red-500 hover:text-white transition duration-300 mx-auto w-full'>برگشت</button>
                          </div>
                        </div>
                      </div>
                    ) : (
                      // ---------- صفحه اصلی چت ----------
                      <div className='flex flex-col h-full'>
                        {/* ===== Header با اطلاعات راننده و خودرو ===== */}
                        <div className='mk-chat-header sticky top-0 z-20 bg-white border-b border-slate-200 shadow-sm'>
                          <div className='max-w-4xl mx-auto px-4 py-3'>
                            <div className='flex items-center gap-3'>
                              <button
                                onClick={() => navigate(-1)}
                                className='w-10 h-10 flex items-center justify-center rounded-full hover:bg-slate-100 active:scale-95 transition-all flex-shrink-0'
                                aria-label="بازگشت"
                              >
                                <IoArrowBack className='text-xl text-slate-700' />
                              </button>

                              <div className='flex-1 min-w-0 flex items-center gap-3'>
                                <div className='relative flex-shrink-0'>
                                  <div className='mk-chat-avatar w-11 h-11 rounded-full bg-[#4F48EC] flex items-center justify-center text-white font-bold overflow-hidden ring-2 ring-white'>
                                    {driverInfo?.full_name?.charAt(0) || 'ر'}
                                  </div>
                                  <div className='absolute -bottom-0.5 -right-0.5 w-3.5 h-3.5 bg-emerald-500 rounded-full border-2 border-white'></div>
                                </div>
                                <div className='flex-1 min-w-0'>
                                  <h1 className='font-bold text-slate-800 text-base truncate'>
                                    {driverInfo?.full_name || 'راننده'}
                                  </h1>
                                  <p className='text-[11px] text-slate-500 flex items-center gap-1'>
                                    <span className='w-1.5 h-1.5 bg-emerald-500 rounded-full'></span>
                                    {carInfo?.name} • {carInfo?.color}
                                  </p>
                                </div>
                              </div>
                            </div>

                            {/* ===== پلاک واقعی ایران ===== */}
                            {carInfo?.plate_code && (
                              <div className='mt-3 flex items-center justify-center'>
                                <div className='inline-flex items-stretch rounded-xl overflow-hidden border border-slate-300 bg-white shadow-sm'>
                                  <div className='mk-chat-plate-country bg-slate-100 px-2 py-1.5 flex flex-col items-center justify-center border-r border-slate-200 min-w-[44px]'>
                                    <span className='text-[9px] text-slate-500 leading-tight'>ایران</span>
                                    <span className='text-base font-bold text-slate-800 leading-tight' style={{ fontFamily: 'IRANSansFaNum' }}>
                                      {carInfo?.plate_code?.part4}
                                    </span>
                                  </div>
                                  <div className='px-3 py-1.5 flex items-center gap-1.5'>
                                    <span className='text-base font-bold text-slate-800' style={{ fontFamily: 'IRANSansFaNum' }}>
                                      {carInfo?.plate_code?.part1}
                                    </span>
                                    <span className='text-base font-bold text-slate-800' style={{ fontFamily: 'IRANSansFaNum' }}>
                                      {carInfo?.plate_code?.part2}
                                    </span>
                                    <div className='w-px h-4 bg-slate-300 mx-1'></div>
                                    <span className='text-base font-bold text-slate-800' style={{ fontFamily: 'IRANSansFaNum' }}>
                                      {carInfo?.plate_code?.part3}
                                    </span>
                                  </div>
                                </div>
                              </div>
                            )}
                          </div>
                        </div>

                        {/* ===== لیست پیام‌ها ===== */}
                        <div
                          className='mk-chat-messages flex-1 overflow-y-auto custom-chat-scroll'
                          id="messagePanel"
                        >
                          <div className='max-w-3xl mx-auto px-4 py-6 flex flex-col gap-2.5'>
                            {allMessages.length === 0 ? (
                              <EmptyChatState />
                            ) : (
                              <>
                                <div className='text-center py-2 chat-msg-enter'>
                                  <span className='mk-chat-day inline-block px-3 py-1 bg-white border border-slate-200 rounded-full text-[11px] text-slate-500'>
                                    {today}
                                  </span>
                                </div>
                                {allMessages.map((item, index) => (
                                  <MessageBubble key={index} item={item} />
                                ))}
                              </>
                            )}
                          </div>

                          {/* پیام خوش‌آمدگویی (فقط در صورت خالی بودن پیام‌ها) */}
                          {noMessages && allMessages.length === 0 && (
                            <div className='text-center px-5 pb-4'>
                              <p className='text-xs text-slate-400'>
                                اینجا می‌توانید به راننده پیام دهید یا پیام‌های راننده را دریافت کنید.
                              </p>
                            </div>
                          )}
                        </div>

                        {/* ===== Input Bar با Quick Replies ===== */}
                        <div className='mk-chat-composer sticky bottom-0 bg-white border-t border-slate-200 shadow-sm'>
                          <div className='max-w-3xl mx-auto px-3 pt-2 pb-3'>
                            {/* Quick Replies */}
                            <div className='flex items-center gap-2 overflow-x-auto pb-2 mb-2 scrollbar-hide custom-chat-scroll'>
                              {defaultMessages.map((text, idx) => (
                                <button
                                  key={idx}
                                  onClick={() => setMessage(text)}
                                  className='flex-shrink-0 px-3.5 py-1.5 bg-slate-100/80 hover:bg-indigo-50 hover:text-[#4F48EC] text-slate-700 text-xs rounded-full whitespace-nowrap transition-all border border-transparent hover:border-indigo-200 active:scale-95'
                                >
                                  {text}
                                </button>
                              ))}
                            </div>

                            {/* Input + Send Button */}
                            <div className='mk-chat-input-shell flex items-end gap-2 bg-slate-100 rounded-2xl p-1.5 focus-within:bg-white focus-within:ring-2 focus-within:ring-[#4F48EC]/20 border border-slate-200 transition-all'>
                              <input
                                type='text'
                                value={message}
                                onChange={(e) => setMessage(e.target.value)}
                                onKeyDown={(e) => {
                                  if (e.key === 'Enter' && !e.shiftKey && message.trim()) {
                                    e.preventDefault();
                                    sendMessage();
                                  }
                                }}
                                className='flex-1 bg-transparent outline-none px-4 py-3 text-slate-800 placeholder-slate-400 text-[15px]'
                                placeholder='پیام خود را بنویسید...'
                              />
                              <button
                                onClick={sendMessage}
                                disabled={!message.trim()}
                                className='mk-chat-send w-11 h-11 flex items-center justify-center rounded-xl bg-[#4F48EC] text-white active:scale-95 disabled:opacity-40 disabled:cursor-not-allowed transition-all flex-shrink-0'
                                aria-label="ارسال پیام"
                              >
                                <IoSend className='text-lg' />
                              </button>
                            </div>

                            <p className='text-center text-[10px] text-slate-400 mt-2'>
                              برای ارسال Enter را بزنید
                            </p>
                          </div>
                        </div>
                      </div>
                    )
                  }
                </>
              )
            }
          </>
        )
      }

      {/* login modal  */}
      <Modal
        isOpen={isModalOpen}
        onRequestClose={handleCancel}
        style={customStyles}
        className="modalMobile"
      >
        <div className=''>
          <button className="custom-modal-close" onClick={handleCancel}>
            &times;
          </button>
          {openLogin ? <LoginRegister /> : showSuccessLogin ? <SuccessLogin /> : null}
        </div>
      </Modal>

      {/* ===== CSS داخلی برای انیمیشن و اسکرول‌بار ===== */}
      <style>{`
        @keyframes chatMsgEnter {
          from {
            opacity: 0;
            transform: translateY(8px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
        .chat-msg-enter {
          animation: chatMsgEnter 0.25s ease-out both;
        }
        .custom-chat-scroll::-webkit-scrollbar {
          width: 6px;
          height: 4px;
        }
        .custom-chat-scroll::-webkit-scrollbar-track {
          background: transparent;
        }
        .custom-chat-scroll::-webkit-scrollbar-thumb {
          background: #cbd5e1;
          border-radius: 8px;
        }
        .custom-chat-scroll::-webkit-scrollbar-thumb:hover {
          background: #94a3b8;
        }
        .scrollbar-hide::-webkit-scrollbar {
          display: none;
        }
        .scrollbar-hide {
          -ms-overflow-style: none;
          scrollbar-width: none;
        }
      `}</style>
    </div>
  );
}

export default ChatPage;